import { useContext } from "react";
import { ThemeValues } from "../ThemeUsage/theme";
import Access from "src/pages/SelfOnboarding/Access";
import { ThemeContext } from "../ThemeUsage/ThemeUsage";
import { SELF_ONBOARDING_ROUTES } from "src/consts/routes";
import { Route, Routes, useLocation } from "react-router-dom";
import { SELF_ONBOARDING_ACCESS_PATHS } from "src/consts/paths";
import AccessFailed from "src/pages/SelfOnboarding/AccessFailed";
import AccessSuccess from "src/pages/SelfOnboarding/AccessSuccess";
import { Box, Container, Grid, Stack, useTheme } from "@mui/material";
import SiteAuthenticationFooter from "../Footer/SiteAuthenticationFooter";
import SelfOnboardingAccessProgressBar from "../SelfOnboardingAccessProgressBar";
import BrandItemThemeChanger from "../BrandIconThemeChanger/BrandIconThemeChanger";
import AuthenticationCallback from "src/pages/SelfOnboarding/AuthenticationCallback";

const SelfOnboardingAccess = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const themeName = useContext(ThemeContext);
  const isUserSelectEnabled = themeName !== ThemeValues.lichtblick;

  return (
    <Stack
      sx={{
        minHeight: "100vh",
        background: theme.palette.background.default,
        userSelect: isUserSelectEnabled ? undefined : "none",
      }}
    >
      <Container
        sx={{
          px: 4,
          flexGrow: 1,
          marginTop: { xs: 0, sm: 12 },
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={4}>
            <Stack gap="50px">
              <Box
                sx={{
                  display: { xs: "none", sm: "flex" },
                }}
              >
                <BrandItemThemeChanger />
              </Box>
              {SELF_ONBOARDING_ACCESS_PATHS.includes(pathname) && (
                <SelfOnboardingAccessProgressBar />
              )}
            </Stack>
          </Grid>

          <Stack
            sx={{
              display: { xs: "flex", sm: "none" },
              justifyContent: "center",
              width: "100%",
              py: 2,
            }}
          >
            <BrandItemThemeChanger />
          </Stack>

          <Grid item xs={12} sm={8} sx={{ paddingLeft: { sm: 5, md: 20 } }}>
            <Routes>
              <Route
                element={<Access />}
                path={SELF_ONBOARDING_ROUTES.ACCESS}
              />
              <Route
                element={<AccessSuccess />}
                path={SELF_ONBOARDING_ROUTES.ACCESS_SUCCESS}
              />{" "}
              <Route
                element={<AccessFailed />}
                path={SELF_ONBOARDING_ROUTES.ACCESS_FAILED}
              />{" "}
              <Route
                element={<AuthenticationCallback />}
                path={SELF_ONBOARDING_ROUTES.AUTHENTICATION_CALLBACK}
              />{" "}
            </Routes>
          </Grid>
        </Grid>
      </Container>
      <SiteAuthenticationFooter />
    </Stack>
  );
};

export default SelfOnboardingAccess;
